import { ChangeDetectionStrategy, Component } from '@angular/core'

import { LayoutCardCarousel } from 'app/core/cms/generated/api-types'
import { CardsCarouselComponent } from 'app/shared/cards-carousel/cards-carousel.component'

import { CmsBlock } from '../../cms-block'
import { LayoutCardsGridComponent } from '../layout-cards-grid/layout-cards-grid.component'

@Component({
  selector: 'pai-layout-card-carousel',
  templateUrl: './layout-card-carousel.component.html',
  styleUrls: ['./layout-card-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardsCarouselComponent],
  providers: [{ provide: CmsBlock, useExisting: LayoutCardsGridComponent }],
})
export class LayoutCardCarouselComponent extends CmsBlock<LayoutCardCarousel> {
  readonly __typename = 'LayoutCardCarousel'
}
